import React, { useState } from "react";
import ReactStars from "react-rating-stars-component";
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import bgBox from "../images/bgBox.jpg";
import Star from "./Star";
import PercentageBar from "./ProgressBar.js";

import Recaptcha from 'react-recaptcha';

const sitekey = "6LcNB3EaAAAAAEmPmeWZT-idBCDu7HLmOAo4uMj-";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  image: {
    background:`linear-gradient(#ec520066, #ec520066), url(${bgBox})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    paddingTop:100,
    paddingBottom: 100,
    '@media (max-width: 960px)': {
       paddingTop: 20,
       paddingBottom: 20,           
    },
  },
  emogiScore: {
      fontSize:30,
  },
  recaptcha:{
    margin:"auto",
    display:"flex",
    justifyContent:"center",
    padding:"15px 0px",
  },
}));



export default function StarRating() {
  const [score, setScore] = useState(0);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [captchaError, setCaptchaError] = useState(false);

  const useReactStars = {
    size: 50,
    count: 5,
    color: "black",
    activeColor: "#ffd700",
    value: 0,
    a11y: false,
    isHalf: false,

    onChange: newValue => {
      setScore(newValue);
      console.log(`Nueva valoración: ${newValue}`);
   
    }
  };

  // create a variable to store the component instance
  let recaptchaInstance;
 

  const callback = () => {
    console.log('Done!!!!');
  };

  // executed once the captcha has been verified
  // can be used to post forms, redirect, etc.
  const verifyCallback = function (response) {
    setCaptchaValue(response);
    setCaptchaError(false);
    console.log(response);
  };

  const expiredCallback = function (response) {
    setCaptchaValue(null);
    console.log("Expired time");
  };

  
  // create a reset function
  const resetRecaptcha = () => {
    setCaptchaValue(null);
    recaptchaInstance.reset();  
    console.log("Reseted captcha");
  };


  const sendFeedback = (name) => {
      const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ score: score, comment:" " })
      };
      if (captchaValue!=null) {
          resetRecaptcha();
          console.log("Sending score");
        fetch('https://8s2qyjli3k.execute-api.us-east-1.amazonaws.com/prod/putscore',requestOptions)
          .then(res=> res.json())
          .then(data=>{
              console.log(data);
              alert('¡Enhorabuena! Se ha guardado el score exitosamente.');
          })
          .catch( error =>{
              console.log(error);
              
          })

      }else{
          setCaptchaError(true);
          console.log("No captcha token");
      }
      

      
  }

  const classes = useStyles();

  return (
    <div className={classes.root}>
        <Grid container  className={classes.image}>
        <Grid item xs={12} sm={6} >
            <div class="reviewContainer">
                <label class="title">Tu valoración es importante</label>
                <div   style={{ display:'flex',justifyContent:"center",width: "100%"}}>
                  <ReactStars   {...useReactStars}/>
                </div>
                <label class="score">{ score>0?<>Puntuación: {score}</>:"No calificado"}</label>
                <div class="">
                  <span className={classes.emogiScore}>{ score===1?<>😥</>:  
                                                        score===2?<>🙃</>:
                                                        score===3?<>😁</>:
                                                        score===4?<>😎</>:
                                                        score===5?<>🤩</>:null   }
                                                        </span>
                </div>
                {
                  score>0? <Button variant="contained" color="primary" onClick={() => sendFeedback()}> Enviar </Button>:null
                }

                <div className={classes.recaptcha}>

                    <Recaptcha
                      ref={e => recaptchaInstance = e}
                      sitekey={sitekey}
                      render="explicit"
                      verifyCallback={verifyCallback}
                      onloadCallback={callback}
                      expiredCallback={expiredCallback}
                      
                    />

                </div>

                {
                  score>0 && captchaError===true?<label style={{color:"red"}}> Completar captcha </label>:null
                }
            </div>
        </Grid>
        <Grid item xs={12} sm={6}>
            <div class="reviewContainer">
              <label class="title">Ponderación general</label>
              <div class="totalWrap">
                  <div class="flexDirection" >
                      <Star />
                      <Star />
                      <Star />
                      <Star />
                      <Star />
                  </div>
                  <label >4.7 de 5</label>
              </div>
            
              <div style={{marginTop: 40}}>
                <div class="spacer">
                  <PercentageBar starText="5" percentage={84} />
                </div>
                <div class="spacer">
                  <PercentageBar starText="4" percentage={9} />
                </div>
                <div class="spacer">
                  <PercentageBar starText="3" percentage={4} />
                </div>
                <div class="spacer">
                  <PercentageBar starText="2" percentage={2} />
                </div>
                <div class="spacer">
                  <PercentageBar starText="1" percentage={1} />
                </div>
              </div>
          </div>      
        </Grid>
      </Grid>   	
    </div>
  );
}

